import { UserAccount } from './user-account';

export class User {
	userId: number;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phoneNumber: string;
	lastLoginDate: Date;
	accounts: Array<UserAccount> = [];
	angelAccount: UserAccount = null;

	constructor(data?: any) {
		if (data) {
			this.firstName = data.firstName;
			this.lastName = data.lastName;
			this.emailAddress = data.emailAddress;
			this.phoneNumber = data.phoneNumber;
			this.userId = data.userId;
			this.lastLoginDate = data.lastLoginDate;
			this.accounts = data.accounts;
		}
	}

	getUserId(): number {
		return this.userId;
	}

	setUserId(value: number): User {
		this.userId = value;
		return this;
	}

	getEmailAddress(): string {
		return this.emailAddress;
	}

	setEmailAddress(emailAddress: string): User {
		this.emailAddress = emailAddress;
		return this;
	}

	getFirstName(): string {
		return this.firstName;
	}

	setFirstName(value: string): User {
		this.firstName = value;
		return this;
	}

	getLastName(): string {
		return this.lastName;
	}

	setLastName(value: string): User {
		this.lastName = value;
		return this;
	}

	toString(): string {
		return `${this.firstName || ''} ${this.lastName || ''}`;
	}

	getPhoneNumber(): string {
		return this.phoneNumber;
	}

	setPhoneNumber(phoneNumber: string): User {
		this.phoneNumber = phoneNumber;
		return this;
	}

	getLastLoginDate(): Date {
		return this.lastLoginDate;
	}

	setLastLoginDate(value: Date): User {
		this.lastLoginDate = value;
		return this;
	}

	getUserAccounts(): Array<UserAccount> {
		return this.accounts;
	}

	setUserAccounts(accounts: Array<UserAccount>): User {
		this.accounts = accounts;

		return this;
	}
}
